// import { update } from "lodash";
import { apiSlice } from '../api/apiSlice';
// import { getRoleMenu, setModuleItems } from "./menuSlice";

export const comptrollerApi = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		GetComptrollerProperty: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncomptroller/get-counts',
				method: 'POST',
				body: data,
				keepUnusedDataFor: 600,
				providesTags: ['comptrollerProperty'],
			}),
		}),
		GetUserByID: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/get-by-id',
				method: 'POST',
				body: data,
				keepUnusedDataFor: 600,
				providesTags: ['entity'],
			}),
		}),
		GetPGRList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/pgr/get-by-company',
				method: 'POST',
				body: data,
			}),
		}),
		// GetTaskCommitteeList: builder.query({
		// 	query: (data) => ({
		// 		url: '/lynorg-service/endpoint/get-committee',
		// 		method: 'POST',
		// 		body: data,
		// 	}),
		// }),
		// GetEntityList: builder.query({
		//   query: (data) => ({
		//     url: "/lynorg-service/endpoint/entity/get-by-type",
		//     method: "POST",
		//     body: data,
		//     keepUnusedDataFor: 600,
		//     providesTags: ["entityList"],
		//   }),
		// }),
		GetControlList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynform-get-controls',
				method: 'POST',
				body: data,
			}),
		}),
		GetDynaFormPropertyList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-company-field-version',
				method: 'POST',
				body: data,
			}),
		}),
		GetLynPropertySpecificList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-ctf',
				method: 'POST',
				body: data,
			}),
		}),
		GetAllLynPropertyList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynproperty/get-by-cfgs',
				method: 'POST',
				body: data,
			}),
		}),
		GetLynFormData: builder.mutation({
			// need to pass userId manually
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/query',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteFunctionMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynfunctionmaster/remove-list',
				method: 'POST',
				body: data,
			}),
		}),

		ActivationHrMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/activation',
				method: 'POST',
				body: data,
			}),
		}),
		BulkActivationHrMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/activation-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteHrMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity/remove-list',
				method: 'POST',
				body: data,
			}),
		}),

		DeleteModule: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-remove-module-list',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteHRPositionMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/remove-list',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteSolution: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynprocess-remove-list',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteVertical: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-remove-vertical-list',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntask-remove-list',
				method: 'POST',
				body: data,
			}),
		}),
		ActivationTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntask-activation-list',
				method: 'POST',
				body: data,
			}),
		}),

		ActivationTaskGroup: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntaskgroup-activation-list',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteTaskGroup: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lyntaskgroup-remove-list',
				method: 'POST',
				body: data,
			}),
		}),
		GetSuperVisorList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/get-valid-supervisor-list',
				method: 'POST',
				body: data,
			}),
		}),
		UserRevive: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynonboard/revive',
				method: 'POST',
				body: data,
			}),
		}),
		ManagementHierarchyActivation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lyncompanyinfo/activation',
				method: 'POST',
				body: data,
			}),
		}),
		FunctionMasterActivation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynfunctionmaster/activation',
				method: 'POST',
				body: data,
			}),
		}),
		PositionMasterActivation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/activation',
				method: 'POST',
				body: data,
			}),
		}),
		FunctionMasterBultActivation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynfunctionmaster/activation-list',
				method: 'POST',
				body: data,
			}),
		}),
		PositionMasterBultActivation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/activation-list',
				method: 'POST',
				body: data,
			}),
		}),
		ModuleBulkActivateHandle: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/grid-module-activation-list',
				method: 'POST',
				body: data,
			}),
		}),
		ModuleBasedWorkList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-module-inbox',
				method: 'POST',
				body: data,
			}),
		}),
		GetWorkListColumnData: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-worklist-data',
				method: 'POST',
				body: data,
			}),
		}),
		ModuleBasedReportsData: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-module-reports',
				method: 'POST',
				body: data,
			}),
		}),
		ActivateConditionMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/activate-condition-master',
				method: 'POST',
				body: data,
			}),
		}),
		CreateVersionConditionMaster: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/condition-master-new-version',
				method: 'POST',
				body: data,
			}),
		}),
		GetUserPreferencesList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/userpreference/get-by-user-all-preference',
				method: 'POST',
				body: data,
			}),
		}),

		GetTableHeaderColor: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/userpreference/get-user-table-header-color',
				method: 'POST',
				body: data,
			}),
		}),

		AddUserPreference: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/userpreference/add',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteUserPreference: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/userpreference/remove',
				method: 'POST',
				body: data,
			}),
		}),
		AddOffDay: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/offday/add',
				method: 'POST',
				body: data,
			}),
		}),
		GetPositionList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynorgstruct/get-company-vacant',
				method: 'POST',
				body: data,
			}),
		}),
		GetOffDayList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/offday/get-by-company-code',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteOffDay: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/offday/remove',
				method: 'POST',
				body: data,
			}),
		}),
		GetGlobalReportsData: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/get-global-reports',
				method: 'POST',
				body: data,
			}),
		}),
		GetConditionMasterValidationList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/validate-condition-master',
				method: 'POST',
				body: data,
			}),
		}),
		AddEntity: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynonboard/add-company',
				method: 'POST',
				body: data,
			}),
		}),
		AddAssignedTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/cre-cmp-add',
				method: 'POST',
				body: data,
			}),
		}),
		AddCascadeTask: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/cre-cmp-add',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeBulkValidation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/val-cmp-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeBulkCreate: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/cre-cmp-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		GetAssignedTaskList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/get-cmp-by-ownerid',
				method: 'POST',
				body: data,
			}),
		}),
		GetCascadeList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/get-cmp-by-ownerid',
				method: 'POST',
				body: data,
			}),
		}),
		GetCascadeListGlobal: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/get-cmp-unrelated-by-employee',
				method: 'POST',
				body: data,
			}),
		}),
		GetSingleTaskHistory: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/get-cmp-history-by-id',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status?.toLowerCase() === 'success',
			}),
		}),
		// GetSingleCascadeHistory: builder.mutation({
		// 	query: (data) => ({
		// 		url: '/lynorg-service/endpoint/cascade/get-cmp-history-by-id',
		// 		method: 'POST',
		// 		body: data,
		// 		validateStatus: (response, result) => response.status === 200 && result?.status?.toLowerCase() === 'success',
		// 	}),
		// }),
		GetSingleCascadeHistory: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/get-cmp-progress-history-by-id',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status?.toLowerCase() === 'success',
			}),
		}),
		UpdateAssignedWork: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/upd-cmp-status-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateAssignedWorkNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/upd-cmp-status-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateProgressOfAssignedWork: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/upd-cmp-progress-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateProgressOfAssignedWorkNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/upd-cmp-progress-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		RejectProgressOfAssignedWork: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/upd-cmp-reject-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		RejectProgressOfAssignedWorkNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/upd-cmp-reject-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteAssignedWork: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/del-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteAssignedWorkNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/del-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		SendBuzzNotification: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/buzz',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateAssignedTaskByID: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/upd-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateAssignedTaskByIDNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/upd-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeDelegation: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/cre-cmp-delegation-task',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeDelegationNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/cre-cmp-delegation-task',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeItemGetByID: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/get-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeItemGetByIDNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/get-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeReAssignById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/upd-cmp-reassign-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		GetEmployeesByCascadeId: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/cascade/get-cmp-employees-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		CascadeMilestoneModificationNew: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lightwork/mod-cmp-progress-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		AddCommittee: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/cre-cmp-add',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateCommittee: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/upd-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		GetCommitteeList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/get-cmp-by-company',
				method: 'POST',
				body: data,
			}),
		}),

		DeleteCommittee: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/del-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),

		GetMemberType: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/get-cmp-member-type-by-company',
				method: 'POST',
				body: data,
			}),
		}),
		GetEmployeeNoPic: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/entity-no-pic/get-by-company',
				method: 'POST',
				body: data,
			}),
		}),
		GetProcessPosition: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessposition-no-pic/company',
				method: 'POST',
				body: data,
			}),
		}),
		GetCommitteeHistory: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/get-cmp-history-committeeId',
				method: 'POST',
				body: data,
			}),
		}),
		GetCommitteeByUser: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/get-cmp-by-company-secretary',
				method: 'POST',
				body: data,
			}),
		}),
		GetCommitteeById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/committee/get-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),

		GetAllFormByCompany: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/process/lynform-template-get-by-company',
				method: 'GET',
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
			providesTags: ['templateForm'],
		}),
		FormActivateDeactivate: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/process/lynform-template-activation-bulk',
				method: 'POST',
				body: data,
			}),
			invalidatesTags: ['templateForm'],
		}),

		TemplateFormList: builder.query({
			query: () => ({
				url: '/lynorg-service/endpoint/process/lynform-template-get-by-company-dropdown',
				method: 'GET',
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
			providesTags: ['templateForm'],
		}),
		CaseReportByDateRange: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report/get-report-data',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		SaveReportSampleList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report/save-solution-report',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		GetReportSampleList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report/get-solution-report-by-user-solution',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),

		// KMA API endpoint
		GetKMAList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/get-by-company',
				method: 'POST',
				body: data,
			}),
		}),
		GetKMAById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/get-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		AddKma: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/add',
				method: 'POST',
				body: data,
			}),
		}),
		UpdateKma: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/save',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteKma: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/delete-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		BulkDeleteKma: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/deletion-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		ActivateKma: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/activate',
				method: 'POST',
				body: data,
			}),
		}),
		BulkActivateKma: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/activation-bulk',
				method: 'POST',
				body: data,
			}),
		}),
		DeactivateKma: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/kma/deactivate',
				method: 'POST',
				body: data,
			}),
		}),
		GetProcessFormStaticPathList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessformstaticpath/company',
				method: 'POST',
				body: data,
			}),
		}),
		SaveProcessFormStaticPath: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessformstaticpath/save',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteProcessFormStaticPath: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynprocessformstaticpath/delete',
				method: 'POST',
				body: data,
			}),
		}),

		AddGraphDefination: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/graph-defination/cre-cmp-add',
				method: 'POST',
				body: data,
			}),
		}),
		GetAllGraphDefination: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/graph-defination/get-cmp-by-company',
				method: 'POST',
				body: data,
			}),
		}),
		GetGraphDefinationById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/graph-defination/get-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		DeleteGraphDefinationById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/graph-defination/del-cmp-by-id',
				method: 'POST',
				body: data,
			}),
		}),
		AddServiceLevel: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynsla/save',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		GetServiceLevelListByStatus: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynsla/get-by-activationStatus',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		GetServiceLevelList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynsla/get-by-companyCode',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		UpdateSingleServiceLevel: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynsla/update',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		SetServiceLevelActive: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/lynsla/activate',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		GetReportList: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report-spec/get-all',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		GetReportById: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report-spec/get-by-id',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		CreateReport: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report-spec/create',
				method: 'POST',
				body: data,
				// validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		UpdateReport: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report-spec/update',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		ReportBulkActive: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report-spec/activate-bulk',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
		ReportBulkDeactivate: builder.mutation({
			query: (data) => ({
				url: '/lynorg-service/endpoint/report-spec/deactivate-bulk',
				method: 'POST',
				body: data,
				validateStatus: (response, result) => response.status === 200 && result?.status === 'SUCCESS',
			}),
		}),
	}),
});

export const {
	useGetUserByIDMutation,
	// useGetEntityListMutation,
	useCaseReportByDateRangeMutation,
	useGetReportSampleListMutation,
	useSaveReportSampleListMutation,
	useGetComptrollerPropertyMutation,
	useGetControlListMutation,
	useGetDynaFormPropertyListMutation,
	useGetLynPropertySpecificListMutation,
	useGetLynFormDataMutation,
	useDeleteFunctionMasterMutation,
	useGetPGRListMutation,
	// useGetTaskCommitteeListQuery,

	useActivationHrMasterMutation,
	useBulkActivationHrMasterMutation,
	useDeleteHrMasterMutation,

	useDeleteModuleMutation,
	useDeleteHRPositionMasterMutation,
	useDeleteSolutionMutation,
	useDeleteVerticalMutation,

	useActivationTaskMutation,
	useDeleteTaskMutation,

	useActivationTaskGroupMutation,
	useDeleteTaskGroupMutation,

	useGetSuperVisorListMutation,
	useUserReviveMutation,

	useManagementHierarchyActivationMutation,

	useCascadeReAssignByIdMutation,
	useGetEmployeesByCascadeIdMutation,
	useFunctionMasterActivationMutation,
	usePositionMasterActivationMutation,
	useFunctionMasterBultActivationMutation,
	usePositionMasterBultActivationMutation,
	useModuleBulkActivateHandleMutation,
	useModuleBasedWorkListMutation,
	useGetWorkListColumnDataMutation,
	useModuleBasedReportsDataMutation,
	useActivateConditionMasterMutation,
	useCreateVersionConditionMasterMutation,
	useGetUserPreferencesListMutation,
	useAddUserPreferenceMutation,
	useDeleteUserPreferenceMutation,
	useGetPositionListMutation,
	useGetTableHeaderColorMutation,
	useGetOffDayListMutation,
	useDeleteOffDayMutation,
	useAddOffDayMutation,
	useGetGlobalReportsDataMutation,
	useGetAllLynPropertyListMutation,
	useGetConditionMasterValidationListMutation,
	useAddEntityMutation,
	useAddAssignedTaskMutation,
	useAddCascadeTaskMutation,
	useCascadeBulkValidationMutation,
	useCascadeBulkCreateMutation,
	useGetAssignedTaskListMutation,
	useGetCascadeListMutation,
	useGetCascadeListGlobalMutation,
	useGetSingleTaskHistoryMutation,
	useGetSingleCascadeHistoryMutation,
	useUpdateAssignedWorkMutation,
	useUpdateAssignedWorkNewMutation,
	useUpdateProgressOfAssignedWorkMutation,
	useUpdateProgressOfAssignedWorkNewMutation,
	useRejectProgressOfAssignedWorkMutation,
	useRejectProgressOfAssignedWorkNewMutation,
	useDeleteAssignedWorkMutation,
	useDeleteAssignedWorkNewMutation,
	useSendBuzzNotificationMutation,
	useUpdateAssignedTaskByIDMutation,
	useUpdateAssignedTaskByIDNewMutation,
	useCascadeDelegationMutation,
	useCascadeDelegationNewMutation,
	useCascadeItemGetByIDMutation,
	useCascadeItemGetByIDNewMutation,
	useAddCommitteeMutation,
	useGetCommitteeListMutation,
	useDeleteCommitteeMutation,
	useUpdateCommitteeMutation,
	useGetMemberTypeMutation,
	useGetEmployeeNoPicMutation,
	useGetProcessPositionMutation,
	useGetCommitteeHistoryMutation,
	useGetCommitteeByUserMutation,
	useGetCommitteeByIdMutation,

	useGetAllFormByCompanyQuery,
	useFormActivateDeactivateMutation,

	useTemplateFormListQuery,

	useGetKMAListMutation,
	useAddKmaMutation,
	useUpdateKmaMutation,
	useDeleteKmaMutation,
	useBulkDeleteKmaMutation,
	useDeactivateKmaMutation,
	useActivateKmaMutation,
	useBulkActivateKmaMutation,
	useGetProcessFormStaticPathListMutation,
	useSaveProcessFormStaticPathMutation,
	useDeleteProcessFormStaticPathMutation,
	useCascadeMilestoneModificationNewMutation,
	useAddGraphDefinationMutation,
	useGetAllGraphDefinationMutation,
	useGetGraphDefinationByIdMutation,
	useDeleteGraphDefinationByIdMutation,

	useAddServiceLevelMutation,
	useGetServiceLevelListMutation,
	useGetServiceLevelListByStatusMutation,
	useSetServiceLevelActiveMutation,
	useUpdateSingleServiceLevelMutation,

	useGetReportListMutation,
	useGetReportByIdMutation,
	useCreateReportMutation,
	useUpdateReportMutation,
	useReportBulkActiveMutation,
	useReportBulkDeactivateMutation,
} = comptrollerApi;
